export const COOKIE_SESS = "SV_CHATWEB_SESS";
export const COOKIE_INFO = "SV_CHATWEB_INFO";
// export const DEFAULT_URL = "http://localhost:6543/api";
export const DEFAULT_URL = "/api";

export const AUTO_ANSWERS = [
    {
        description: "YA HAY REPORTE",
        value: "Sr. usuario, ya contamos con reportes de la zona, el caso este recomendado al Centro de Supervisión y Maniobras, para dar pronta solución a la falla del servicio.",
    },
    {
        description: "SALUDO",
        value: "Buen Día, Sr usuario se ha comunicado a la línea 115 de la Electrificadora del Meta SA ESP, Para poder generar su reporte se requiere la siguiente información: Código de cliente, nombre de quien reporta, numero de celular, clase de falla o daño, si afecta solo su predio o todo el sector.",
    },
    {
        description: "CÓDIGO",
        value: "Señor usuario, nuestro sistema no reconoce el código digitado, por favor digítelo nuevamente.",
    },
    {
        description: "SU REPORTE",
        value: "Sr. usuario gracias por su amable espera en la línea, ya se generó su reporte de falla en el servicio, pronto se asignará una cuadrilla que verificará y atenderá su reporte, con el fin de normalizar el servicio lo más pronto posible. Su número de reporte es:",
    },
    {
        description: "LÍNEA",
        value: "Sr. Usuario esta línea solo está habilitada para reporte de daños y fallas en el servicio, por favor comuníquese a la línea (608) 6610095 o al 018000918615 para que le puedan resolver sus inquietudes. ",
    },
    {
        description: "RECONEXIÓN",
        value: "Señor usuario, La reconexión del servicio, se realizará dentro de las 24 horas laborales siguientes a la aplicación del pago de la factura en nuestro sistema.",
    },
    {
        description: "MÓVIL",
        value: "Sr. usuario su reporte ya ha sido informado al Centro de Supervisión y Maniobras y asignada una móvil para la atención y normalización del servicio, pedimos paciencia, pues tenemos varios reportes de fallas pendientes por atender y los mismos se atienden según su orden y urgencia.",
    },
    {
        description: "DESPEDIDA",
        value: "Gracias por haberse comunicado con la línea 115 de la electrificadora del meta SA ESP, si desea comunicarse con nosotros nuevamente, esta línea está habilitada 24/7. ¡EMSA trabajamos con energía!",
    },
    {
        description: "FALLA CIRCUITO",
        value: "Sr. usuario en estos momentos estamos presentando falla en el circuito que lleva la energía al sector, afectando la normal prestación del servicio, nuestro personal operativo ya se encuentra trabajando para normalizar el servicio de energía.",
    },
    {
        description: "NO TIEMPO ESTIMADO",
        value: "Sr. usuario no podemos brindarle un tiempo estimado de atención, ya se está llevando a cabo el procedimiento correspondiente para solucionar el problema y normalizar el servicio. Recuerde que los reportes de fallas se atienden según su orden y urgencia.",
    },
    {
        description: "ESTADO PREDICTIVO",
        value: "Efectivamente su reporte sigue abierto, vamos a recomendar nuevamente al Centro de Supervisión de Maniobras, para que una de nuestras cuadrillas atienda su reporte lo más pronto posible.",
    },
    {
        description: "ALUMBRADO PÚBLICO",
        value: "Sr. usuario las fallas de alumbrado público deben ser reportadas a la empresa de iluminación Alborada Villavicencio, las líneas de atención son 3204962800 o 6716677, y si es fuera de Villavicencio debe reportarlas en la alcaldía de su municipio.",
    },
    {
        description: "LECTURA",
        value: "Sr. usuario si no le realizaron la toma de lectura de su medidor de energía, puede comunicarse a través de la línea WhatsApp 3235741766 y enviar su reporte de lectura informar la no entrega de factura.",
    },
    {
        description: "SEÑOR USUARIO",
        value: "Sr. usuario, me puede indicar si la falla del servicio solo afecta su predio o todo el sector?",
    },
    {
        description: "OAC",
        value: "Sr. usuario le recordamos que este medio solo está habilitado para reportar fallas en el servicio de energía, para esta clase de reclamación por favor acercarse a la oficina de Atención al Cliente más cercana.",
    },
    {
        description: "FINANCIACIONES",
        value: "Sr. Usuario, para acceder a diferentes opciones de financiamiento, EMSA ESP habilitó el siguiente canal de atención, WhatsApp 3122443313 o 3122443307 de lunes a viernes 7:00am a 4:00pm. ",
    },
    {
        description: "UBICACIÓN.",
        value: "Sr. Usuario, por favor nos podría brindar información más específica o un punto de referencia para llegar a su predio.",
    },
];
